interface PanelProps {
  children: React.ReactChild;
  title: string;
}

export default function Panel(props: PanelProps) {
  return <>{props.children}</>;
}
